module.exports = __webpack_public_path__ + "pin.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/pin.svg?color1=%23333333&color2=
// module id = 2208
// module chunks = 67